export default __webpack_public_path__ + "static/media/section3-img4.3795af8d.png";